module.exports = __webpack_public_path__ + "img/marker_normal.215fb0d1.svg";